/* eslint-disable max-statements */
import { useCallback } from 'react';
import { useParams } from 'react-router';
import { useNavegate } from 'App/hooks';
import { NE_PRINT_LABEL_SOURCE } from 'domains/NuvemEnvioCommons/constants';
import { trackingNuvemEnvioPrintDocumentsPage } from 'domains/NuvemEnvioCommons/tracking';
import { NUVEM_ENVIO_ORDERS_ROUTES } from '../../routes';
import { buildPrintNELabelPath } from '../../utils';

interface GoToPrintNuvemEnvioLabelsPageProps {
  fulfillmentOrderIds: string[];
  source: NE_PRINT_LABEL_SOURCE;
  orderId?: string;
}

function useGoToPrintNuvemEnvioLabelsPage() {
  const { goTo } = useNavegate();
  const { id } = useParams<{ id: string }>();

  const goToPrintNuvemEnvioLabelsPage = (
    params: GoToPrintNuvemEnvioLabelsPageProps,
  ) => {
    const { fulfillmentOrderIds } = params;

    if (!fulfillmentOrderIds.length) return;

    goTo(
      buildPrintNELabelPath({
        source: params.source,
        fulfillmentOrderIds,
        orderId:
          params.source === NE_PRINT_LABEL_SOURCE.ORDER_DETAILS ? id : '',
      }),
    );
  };

  const goToPrintNuvemEnvioLabelDocumentsPage = useCallback(
    (params: GoToPrintNuvemEnvioLabelsPageProps) => {
      const { fulfillmentOrderIds, source, orderId } = params;

      if (!fulfillmentOrderIds.length) return;

      trackingNuvemEnvioPrintDocumentsPage(fulfillmentOrderIds.length);

      goTo(
        `${
          NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintDocuments
        }?orderId=${orderId}&fulfillmentOrderIds=${fulfillmentOrderIds.join(
          ',',
        )}&source=${source}`,
      );
    },
    [goTo],
  );

  return {
    goToPrintNuvemEnvioLabelsPage,
    goToPrintNuvemEnvioLabelDocumentsPage,
  };
}

export default useGoToPrintNuvemEnvioLabelsPage;
